import { FC, createContext, useContext, Dispatch, SetStateAction } from "react";
import { WithChildren } from "../../../../../../_metronic/helpers";
import { 
    IDLMWebDOCModel, initDLMWebDOCModelValues, 
    IDLMWebROIModel, initDLMWebROIModelValues,
} from "../../../../core/doclabel";

import { cloneDeep } from "lodash";

export type DLMResponseFormContextProps = { 
    appID: number
    workflow: string    
    appState: string
    
    doClose: Function            
    // generate DOC Parameters
    baseDOC: IDLMWebDOCModel
    setBaseDOC: Dispatch<SetStateAction<IDLMWebDOCModel>>
    genDOCIndex: number
    setGenDOCIndex: Dispatch<SetStateAction<number>>
    onGenDOC: Function | undefined
    setOnGenDOC: Dispatch<SetStateAction<Function | undefined>>
    generateDOC: Function

    // generate ROI Parameters
    baseROI : IDLMWebROIModel
    setBaseROI: Dispatch<SetStateAction<IDLMWebROIModel>>
    genROIIndex: number
    setGenROIIndex: Dispatch<SetStateAction<number>>
    onGenROI: Function | undefined
    setOnGenROI: Dispatch<SetStateAction<Function | undefined>>
    generateROI: Function

    // select label parameters
    labelSeries: number
    setLabelSeries: Dispatch<SetStateAction<number>>
    labelSelection: Array<string> | null
    setLabelSelection: Dispatch<SetStateAction<Array<string> | null>>
    targetLabels: Array<string> | null
    setTargetLabels: Dispatch<SetStateAction<Array<string> | null>>
    onLabelSelect: Function | undefined
    setOnLabelSelect: Dispatch<SetStateAction<Function | undefined>>
    
    siteID?: number,
    siteState?: string
}

const initialDLMResponseFormContextProps  = {
    appID : 0,
    workflow: '',
    appState: '',
    
    doClose: () => {},

    baseDOC: cloneDeep(initDLMWebDOCModelValues),
    setBaseDOC: () => {},
    genDOCIndex: 0,
    setGenDOCIndex: () => {},
    onGenDOC: () => {},
    setOnGenDOC: () => {},
    generateDOC: () => {},

    baseROI: cloneDeep(initDLMWebROIModelValues),
    setBaseROI: () => {},
    genROIIndex: 0,
    setGenROIIndex: () => {},
    onGenROI: () => {},
    setOnGenROI: () => {},
    generateROI: () => {},

    labelSeries: -1,
    setLabelSeries: () => {}, 
    labelSelection: null, 
    setLabelSelection: () => {},
    targetLabels: null, 
    setTargetLabels: () => {},
    onLabelSelect: undefined, 
    setOnLabelSelect: () => {},    
    
    siteID: 0,
    siteState: '',
}

const DLMResponseFormContext = createContext<DLMResponseFormContextProps>(initialDLMResponseFormContextProps);

const DLMResponseFormContextProvider: FC<DLMResponseFormContextProps & WithChildren> = ({
    appID, workflow, appState, doClose, 
    baseDOC, setBaseDOC,
    genDOCIndex, setGenDOCIndex, onGenDOC, setOnGenDOC, generateDOC,     
    baseROI, setBaseROI,
    genROIIndex, setGenROIIndex, onGenROI, setOnGenROI, generateROI, 
    labelSeries, setLabelSeries,
    labelSelection, setLabelSelection, targetLabels, setTargetLabels,
    onLabelSelect, setOnLabelSelect, siteID = 0, siteState = '',    
    children
}) => {
    return(
    <DLMResponseFormContext.Provider value={{
        appID, workflow, appState, doClose, 
        baseDOC, setBaseDOC,
        genDOCIndex, setGenDOCIndex, onGenDOC, setOnGenDOC, generateDOC,
        baseROI, setBaseROI,
        genROIIndex, setGenROIIndex, onGenROI, setOnGenROI, generateROI,
        labelSeries, setLabelSeries,
        labelSelection, setLabelSelection, targetLabels, setTargetLabels,
        onLabelSelect, setOnLabelSelect, siteID, siteState,        
    }}>
        {children}
    </DLMResponseFormContext.Provider>
    )
}

const useDLMResponseFormContext = () => useContext(DLMResponseFormContext);

export { DLMResponseFormContextProvider, useDLMResponseFormContext}